module.exports = [
    {
        key: '',
        name: 'Escritorio',
        icon: 'laptop',
        clickable: true
    }, {
        key: 'hotels',
        name: 'Empresas',
        icon: 'hotel',
    }, {
        key: 'all_users',
        name: 'Usuarios',
        icon: 'male',
        child: [
            {
                key: 'list-providers',
                name: 'Proveedores',
                icon: 'circle'
            },
            {
                key: 'list-sellers',
                name: 'Vendedores',
                icon: 'circle'
            },
            {
                key: 'list-users',
                name: 'Administradores',
                icon: 'circle'
            }
        ]
    }, {
        key: 'clients',
        name: 'Clientes',
        icon: 'users'
    }, {
        key: 'activities',
        name: 'Actividades',
        icon: 'book',
        child: [
            {
                key: 'list-activities',
                name: 'Todas las actividades',
                icon: 'circle'
            },
            {
                key: 'list-categories',
                name: 'Categorías',
                icon: 'circle'
            }
        ]
    }, {
        key: 'tours',
        name: 'Tours',
        icon: 'swimmer'
    }, {
        key: 'reports',
        name: 'Reportes',
        icon: 'chart-line',
        child: [
            {
                key: 'company-report',
                name: 'Por empresa',
                icon: 'circle'
            },
            {
                key: 'tour-report',
                name: 'Por tour',
                icon: 'circle'
            }
        ]
    },
]


// WEBPACK FOOTER //
// ./src/utils/menu.js